export default __webpack_public_path__ + "static/media/setReadingGoalDark@2x.e0d2e142.png";